export const SUPPORT_EMAIL = 'moneysupport@zenbusiness.com';
export const SUPPORT_PHONE = '1 (844) 4-ZENBIZ';
